export default __webpack_public_path__ + "static/caravan-loan-b1ea3760c155f1491a5729f2ac9c798d.webp";